import { Loadable } from '@gdp/react-app/lib/helpers/loadable';

export const LoadableOrderDepositRoutes = Loadable(
  './OrderDepositRoutes',
  () => import(/* webpackChunkName: "OrderDeposit" */ './OrderDepositRoutes'),
  () => [(require as any).resolveWeak('./OrderDepositRoutes')]
);